import { useEffect, useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import {
  useOrders,
  updateProduct,
  addProduct,
  deleteProduct,
  setBadProduct
} from "../../context/orders/OrdersState";

const Quantity = ({ product, orderId, onSaved }) => {
  const [ordersState, ordersDispatch] = useOrders();
  const { actions } = ordersState;
  const { quantity, max_quantity } = product;
  const [updateHelper, setUpdateHelper] = useState(0);
  const [showMaxQuantityDialog, setShowMaxQuantityDialog] = useState(false);
  const [pendingOverMaxQuantity, setPendingOverMaxQuantity] = useState(null);
  const hasMaxLimit = max_quantity != null && max_quantity > 0;
  const maxAllowed = hasMaxLimit ? max_quantity : 1000;
  const canExceedMaxQuantity = actions?.includes('exceedMaxQuantity');

  const showMaxQuantityAlert = (requestedQty) => {
    if (hasMaxLimit) {
      setPendingOverMaxQuantity(requestedQty);
      setShowMaxQuantityDialog(true);
    }
  };

  useEffect(() => {
    if (updateHelper > 0) {
      const timer = setTimeout(UpdateOnServer, 500);
      return () => clearTimeout(timer);
    }
  }, [updateHelper]);

  // document.body.onclick = function() {};
  const upClick = async (e) => {
    if (product.quantity === null || product.quantity === 0) {
      if (product.id == 1081 || product.id == 2478 || product.price == 0) {
        setBadProduct(ordersDispatch, true);
      } else {
        product.quantity = 1;
        addProduct(ordersDispatch, orderId, product, false, true);
        setUpdateHelper(updateHelper + 1);
      }
    } else if (parseInt(product.quantity) >= maxAllowed) {
      showMaxQuantityAlert(parseInt(product.quantity) + 1);
    } else {
      const oldQuantity = product.quantity;
      const newQty = parseInt(product.quantity) + 1;
      if (newQty > maxAllowed) {
        showMaxQuantityAlert(newQty);
        product.quantity = maxAllowed;
      } else {
        product.quantity = newQty;
      }
      updateProduct(ordersDispatch, orderId, product, false, oldQuantity);
      setUpdateHelper(updateHelper + 1);
    }
  };
  const downClick = async (e) => {
    if (parseInt(product.quantity) > 0) {
      // delete product
      if (parseInt(product.quantity) === 1) {
        product.quantity = 0;
        deleteProduct(ordersDispatch, orderId, product);
       

      } else {
        const oldQuantity = product.quantity;
        product.quantity = parseInt(product.quantity) - 1;
         updateProduct(ordersDispatch, orderId, product, false, oldQuantity);
       

      }
    }
    setUpdateHelper(updateHelper+1);

  };

  // changing quantity input
  const onChange = async (e) => {
    // add new product or change quantity
    // eslint-disable-next-line eqeqeq
    const inputVal = e.target.value;
    const parsed = parseInt(inputVal, 10);

    if (
      inputVal == +inputVal &&
      parsed > 0 &&
      Math.round(inputVal) == inputVal
    ) {
      if (parsed > maxAllowed) {
        showMaxQuantityAlert(parsed);
      } else {
        const quantityToSet = parsed;
        if (product.quantity === 0 || product.quantity === null) {
          if (product.id == 1081 || product.id == 2478 || product.price == 0) {
            setBadProduct(ordersDispatch, true);
          } else {
            product.quantity = quantityToSet;
            addProduct(ordersDispatch, orderId, product, false, true);
            setUpdateHelper(updateHelper + 1);
          }
        } else {
          const oldQuantity = product.quantity;
          product.quantity = quantityToSet;
          updateProduct(ordersDispatch, orderId, product, false, oldQuantity);
          setUpdateHelper(updateHelper + 1);
        }
      }
    }

    // delete product
    if (
      product.quantity !== 0 &&
      (e.target.value == 0 || e.target.value === "")
    ) {
      // disabling - not to interupt in the delete process. will be inabled in onBlur
      e.target.disabled = true;
      product.quantity = 0;
      deleteProduct(ordersDispatch, orderId, product);
      setUpdateHelper(updateHelper + 1);
    }

  };

  /**
   * when leaving field - call update with server = true
   */
  const onBlur = (e) => {
    // eslint-disable-next-line eqeqeq
    // if (
    //   e.target.value == +e.target.value &&
    //   parseInt(e.target.value) > 0 &&
    //   parseInt(e.target.value) <= 1000
    // ) {
    //   // updating with true to indicate server update
    //   updateProduct(ordersDispatch, orderId, product, true);
    // }
    e.target.disabled = false;
  };

  const UpdateOnServer = async (e) => {
    if (parseInt(product.quantity) >= 1) {
      updateProduct(ordersDispatch, orderId, product, true);
      console.log("Server update finished!");
      if (onSaved) {
        onSaved();
        console.log("Triggering onSaved message");
      }else{
        console.log('bwwwwwwww')
      }

    }
  };

  const onClick = (e) => {
    e.target.select();
  };

  // this prevents the scrolling on the number to change it
  const onWheel = (e) => {
    e.target.blur();
  };

  return (
    <>
      <div className="table_qty">
        <button className="plus-btn" onClick={upClick}>
          <i className="fas fa-plus"></i>
        </button>
        <input
          className={
            product.is_missing == 1  ? "quantity-input missing" : (quantity > 0 ? "quantity-input quantity-pos" : "quantity-input")
          }
          type="number"
          value={quantity ?? 0}
          onChange={onChange}
          onClick={onClick}
          onBlur={onBlur}
          max="999"
          onWheel={onWheel}
        />
        <button className="minus-btn" onClick={downClick}>
          <i className="fas fa-minus"></i>
        </button>
      </div>
      {showMaxQuantityDialog && (
        <Dialog
          title="שימ/י לב:"
          onClose={() => { setShowMaxQuantityDialog(false); setPendingOverMaxQuantity(null); }}
          className="pop-up pop-up-orange"
        >
          <p>הכמות המקסימלית המותרת היא {maxAllowed}</p>
          <DialogActionsBar>
            {!canExceedMaxQuantity && (
              <button
                className="submit btn"
                onClick={() => { setShowMaxQuantityDialog(false); setPendingOverMaxQuantity(null); }}
              >
                אישור
              </button>
            )}
            {canExceedMaxQuantity && (
              <>
                <button
                  className="cancel btn"
                  onClick={() => { setShowMaxQuantityDialog(false); setPendingOverMaxQuantity(null); }}
                >
                  ביטול
                </button>
                <button
                  className="submit btn"
                  onClick={() => {
                    const oldQ = product.quantity;
                    product.quantity = pendingOverMaxQuantity;
                    updateProduct(ordersDispatch, orderId, product, false, oldQ);
                    setShowMaxQuantityDialog(false);
                    setPendingOverMaxQuantity(null);
                    setUpdateHelper(updateHelper + 1);
                  }}
                >
                  שינוי בכל זאת
                </button>
              </>
            )}
          </DialogActionsBar>
        </Dialog>
      )}
    </>
  );
};

export default Quantity;
